(ns app.front.ui.termination-info
  (:require [app.front.ui.rich-text :as ui-rt]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.user.model :as user-model]))

(defn termination-info
  "Banner shown on top of the workspace when a phase has been terminated.

  Pass `:rich-text-reason?` when the reason attribute holds rich text rather than plain text."
  [entity {:keys [tr reason-attr by-attr ts-attr descr-tr-key rich-text-reason?]}]
  (when (contains? entity ts-attr)
    (let [reason    (reason-attr entity)
          date-time (<sub [::date-util/date-time-fn])]
      [:div.p-6.px-8.bg-white.border-dashed.border-ui-red.border.rounded
       [:h2.uppercase.pb-4.bold (tr [(:domain/state entity)])]
       [:h3.pb-2.font-semibold.text-base (tr [reason-attr])]
       (if rich-text-reason?
         [ui-rt/editor {:id                 (str "termination-reason-" (name reason-attr))
                        :initial-html-value reason}]
         [:p reason])
       [:p.py-0
        (tr [descr-tr-key]
            [(user-model/full-name (by-attr entity))
             (-> entity
                 ts-attr
                 date-time)])]])))
